import { Button, Card, Col, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { RiPencilFill } from "react-icons/ri";
import InfoPrimaryPatient from "./InfoPrimaryPatient";
import InfoSencondaryPatient from "./InfoSencondaryPatient";
import SendDocPatient from "./SendDocPatient";
import SendEncuetaConsultorio from "./SendEncuetaConsultorio";

function CardDataClientMexico({t, cita, setShowSuccess, setShowModalServer, setErrorServer, handleShowEditDataMexico, noComienza}){
    const { patientDTO } = cita

    return (
        <Card className="shadow-1 my-3">
            <Card.Body>
                <h6>{`${patientDTO.name} ${patientDTO.middleName ?? ''} ${patientDTO?.lastName} ${patientDTO.seccondSurname ?? ''}`}</h6>
                {patientDTO.name && !noComienza && <Button type="button" variant="outline-info" 
                    className="position-absolute topright-absolute" 
                    size="sm"
                    onClick={handleShowEditDataMexico}
                >
                    <RiPencilFill />
                </Button>}
                <Row>
                    <Col xs="8" md="8">
                        <InfoPrimaryPatient paciente={patientDTO} cita={cita}/>                        
                    </Col>
                    <Col xs="4" md="4">
                        <InfoSencondaryPatient paciente={patientDTO} cita={cita}/>
                    </Col>
                    <Col xs="12" md="12">
                        <Card>
                            <Card.Body>
                                <label className="text-secondary d-block mb-0">Motivo de consulta</label>
                                <label className="m-0 text-secondary">{`${cita?.motivoConsulta ? cita.motivoConsulta : 'Sin motivo'}`}</label>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                {!noComienza && <SendDocPatient cita={cita} setShowSuccess={setShowSuccess} setShowModalServer={setShowModalServer} setErrorServer={setErrorServer}/>}
                <SendEncuetaConsultorio noComienza={noComienza} cita={cita} setShowSuccess={setShowSuccess} setShowModalServer={setShowModalServer} setErrorServer={setErrorServer}/>
            </Card.Body>
        </Card>
    )
}

export default withTranslation()(CardDataClientMexico)